import { Button } from '@mui/material'
import LoadingSpinner from 'components/ui/LoadingSpinner'
import styled from 'styled-components'

interface Props {
  status?: RequestStatus
  text: JSX.Element | string
  id?: string
  className?: string
  onClick?: () => void
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset' | undefined
}

export default function SearchButton({
  status = 'idle',
  text,
  id,
  className,
  onClick,
  disabled = false,
  type,
}: Props): JSX.Element {
  const elementId = id || Math.random().toString(36).substring(7)
  return (
    <StyledButton
      type={type}
      color="primary"
      variant="contained"
      disabled={status === 'loading' || disabled}
      id={elementId}
      className={className}
      onClick={onClick}
    >
      {status === 'loading' ? <LoadingSpinner size={24} /> : text}
    </StyledButton>
  )
}

const StyledButton = styled(Button)`
  text-transform: none;
`
